/**
 * Triggers an custom event on Splunk RUM.
 * @param workflowName the string that will identify the event on Splunk RUM.
 */
export const triggerSplunkCustomEvent = (workflowName: string): void => {
  const span = window.Shell.v1?.monitoring?.startSpan(workflowName, {
    'workflow.name': 'pces-jwv-user-tenant-onboarding-app-' + workflowName
  });

  span?.end();
};
